/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 *
 * The sign-in screen — the first thing anyone sees, and until now the only
 * screen with no branding on it at all.
 *
 * `sentinelle-logo.png` is the full 858×200 wordmark lockup (mark plus
 * SENTINELLE·IA). It shipped in `public/` from the start but nothing on the web
 * ever referenced it — the sidebar used the 144px square mark instead, which is
 * why the logo looked like a thumbnail everywhere and was missing here.
 */

import { useAuth } from "react-oidc-context";

import { usePrefs } from "../../i18n/index.tsx";

export function LoginPage() {
  const auth = useAuth();
  const { t } = usePrefs();

  return (
    <div className="grid min-h-screen place-items-center bg-paper p-6">
      <div className="w-full max-w-sm text-center">
        {/* Sized by WIDTH, with height left to follow the 4.29:1 aspect.
            Constraining the height of a wide lockup is what shrinks it to a
            smudge. */}
        <img
          src="/sentinelle-logo.png"
          alt="Sentinelle-IA"
          width={858}
          height={200}
          className="mx-auto mb-8 w-64 max-w-full"
        />

        <div className="card p-8">
          <h1 className="font-serif text-2xl font-semibold text-ink">{t("app.name")}</h1>
          <p className="mt-2 text-sm text-ink-3">{t("app.tagline")}</p>

          {auth.error && (
            <p className="mt-4 rounded-lg border border-danger/30 bg-danger/5 p-2.5 text-sm text-danger">
              {t("auth.failed")} {auth.error.message}
            </p>
          )}

          <button className="btn-primary mt-6 w-full"
                  onClick={() => void auth.signinRedirect()}>
            {t("common.signin")}
          </button>
        </div>
      </div>
    </div>
  );
}
